import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <Hook data-id="element-2" />
      <Problem data-id="element-3" />
      <UniqueMechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Pricing data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}